export default "__VITE_ASSET__BY16ErSO__"